const translation = {
  PROMOTION_VALUE_OFF_PERCENTAGE:
    "Get {{value}} % off up to {{maximum}} {{currency}}. {{times}} trips maximum",
  PROMOTION_VALUE_OFF_AMOUNT:
    "Get {{value}} {{currency}} off up to {{maximum}} {{currency}}. {{times}} trips maximum",
  PROMOTION_VALUE_PERCENTAGE:
    "Get  {{100 -value}} % off up to {{maximum}} {{currency}}. {{times}} trips maximum",
  PROMOTION_VALUE_AMOUNT:
    "Pay {{value}} {{currency}} only! Max discount up to {{maximum}} {{currency}}. {{times}} trips maximum!",
};
export default translation;



// WEBPACK FOOTER //
// ./src/i18n/en.js